<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('accreditations')"
          :directory="$t('requests')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            <i data-feather="plus" class="pr-2" />
            {{ $t("new_request") }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="licenses">
      <div v-for="(value, key) in licenses" :key="key">
        <div class="alert alert-info alert-dismissible fade show" role="alert" v-if="value.state_license == 1 && value.days_license > 20">
          Licencia para {{ value.accreditation_activity.name }}, <strong>VIGENTE</strong>. Su licencia tiene {{value.days_license}} días habiles.
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="value.state_license == 1 && value.days_license <= 20">
          Licencia para {{ value.accreditation_activity.name }}, <strong>VIGENTE</strong>. Se le informa que su licencia tiene una vigencia de {{value.days_license}} días, por favor tramite el pago de su proxima licencia.
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="value.state_license == 2">
          Licencia para {{ value.accreditation_activity.name }}, <strong>CADUCADO</strong>. Por favor ingrese el pago correspondiente al siguiente período, caso contrario se bloqueara la plataforma.
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <ApplicationAddModal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :accreditation-area-list="accreditationAreaList"
      :accreditation-activity-list="accreditationActivityList"
      :accreditation-type-list="accreditationTypeList"
      @close-modal="closeAddEditModal"
    />

    <document-modal
      v-if="documentModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeDocumentModal"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="application-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este registro?"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  name: "ApplicationTable",
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "ApplicationTable",
      rowData: {},
      licenses: {},
      options: {
        name: "demo_crud",
        url: `${actions.ACCREDITATIONS_APPLICATIONS}/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          {
            title: "Documentos",
            icon: "file-text",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
          },
          {
            title: "Histórico",
            icon: "book",
            type: "none",
          },
        ],
        filters: [
          {
            title: "Área",
            type: "checkbox",
            key: "accreditation_area",
            option: [],
          },
          {
            title: "Actividad",
            type: "checkbox",
            key: "accreditation_activity",
            option: [],
          },
          {
            title: "Tipo",
            type: "checkbox",
            key: "accreditation_type",
            option: [],
          },
          {
            title: "Estado",
            type: "drop-down-filter",
            key: "status",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      documentModalActive: false,
    };
  },
  computed: {
    accreditationAreaList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
      ];
    },
    accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    },
    accreditationTypeList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationTypes,
      ];
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  watch: {
    "$store.state.accreditation.accAppOptions": function () {
      this.searchAndSelectFilterOptions();
    },
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#application-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    /**
     * $emit form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        if (
          this.rowData.status.code != "100" &&
          this.rowData.status.code != "102"
        ) {
          this.$toastr.e(
            "Solo se pueden eliminar registros en estado borrador"
          );
          return;
        }
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        if (this.rowData.status.code == "100") {
          this.selectedUrl = `${actions.ACCREDITATIONS_APPLICATIONS}/${rowData.id}`;
          // this.openAddEditModal();
          window.location = this.selectedUrl;
        }
        if (this.rowData.status.code == "112") {
          this.selectedUrl = `${actions.ACCREDITATIONS_APPLICATIONS}/${rowData.id}`;
          // this.openAddEditModal();
          window.location = this.selectedUrl;
        }
        if (this.rowData.status.code == "102") {
          this.selectedUrl = `${actions.ACCREDITATIONS_APPLICATIONS}/payment/${rowData.id}`;
          window.location = this.selectedUrl;
        }
        if (this.rowData.status.code == "104") {
          this.$toastr.w("Solicitud en etapa de revisión");
        }
      } else if (actionObj.title == "Histórico") {
        this.selectedUrl = `/historical/accreditation/${rowData.id}`;
        const w = window.open(this.selectedUrl, "_blank");
        w.focus();
      } else if (actionObj.title == "Documentos") {
        this.$store.dispatch("postEmailAccessAcc",rowData.id);
        this.selectedUrl = `/audit/accreditation/${rowData.id}/show`;
        this.openDocumentModal();
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit form confirmation modal
     */
    confirmed() {
      let url = `${actions.ACCREDITATIONS_APPLICATIONS}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#application-delete").modal("hide");
          this.cancelled();
          // this.$toastr.s(response.data.message);
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    data() {
      this.$store.dispatch("getAccAppOptions");
      let url = `/accreditations/oec/manage-licenses/showAllLicensesOec?accAppId=${1}`;
      this.axiosGet(url).then((response) => {
        this.licenses = response.data;

        const hasExpiredLicense = this.licenses.some(license => license.state_license === 2);
        if (hasExpiredLicense) {
            // Redirigir a la URL si se encuentra una licencia vencida
            window.location.href = '/accreditations/oec/manage-licenses';
        }
      })
    },

    searchAndSelectFilterOptions() {
      const area = this.options.filters.find(
        (element) => element.key === "accreditation_area"
      );
      area.option =
        this.$store.state.accreditation.accAppOptions.accreditationAreas;

      const activity = this.options.filters.find(
        (element) => element.key === "accreditation_activity"
      );
      activity.option =
        this.$store.state.accreditation.accAppOptions.accreditationActivities;

      const type = this.options.filters.find(
        (element) => element.key === "accreditation_type"
      );
      type.option =
        this.$store.state.accreditation.accAppOptions.accreditationTypes;

      const status = this.options.filters.find(
        (element) => element.key === "status"
      );
      status.option = this.$store.state.accreditation.accAppOptions.status;
    },

    openDocumentModal() {
      this.documentModalActive = true;
    },

    closeDocumentModal() {
      $("#document-modal").modal("hide");
      this.documentModalActive = false;
      this.reSetData();
    },
  },
};
</script>
